<template>
  <div class="app-container">
    <BjRouteTabs :route-list="BUSINESS_ORDER_TIMELINESS" />
    <div class="width-full flex-spacebetween" style="padding:10px 40px">
      <BjDateTimerangePicker v-model="lineChart.queryParamsTime_pay" :default-time="Date.now() - 30 * 24 * 3600 * 1000" />
      <el-radio-group v-model="lineChart.tabData">
        <el-radio-button label="0">day</el-radio-button>
        <el-radio-button label="1">week</el-radio-button>
        <el-radio-button label="2">month</el-radio-button>
      </el-radio-group>
    </div>
    <LineChart :chart-data="lineChart.lineChartData2" />
  </div>
</template>
<script>
import { BUSINESS_ORDER_TIMELINESS } from '@/utils/constants';
import LineChart from './LineChart';
import { afterApi } from '@/api';
import moment from 'moment';
const echarts = require('echarts/lib/echarts');
export default {
  name: 'BusinessOrderTimelinessOnTime',
  components: { LineChart },
  data() {
    return {
        BUSINESS_ORDER_TIMELINESS,
        lineChart: {
          tabData: '0',
          lineChartData2: {
            title: {
              text: 'ERP, SAP, and WMS System Percentage Of On-time Processing',
              textStyle: {
                align: 'center',
                color: '#082dc3',
                fontSize: 20,
              },
              top: '7%',
              left: '40',
            },
            series: [
              {
                name: 'ERP On Time Portion',
                type: 'line',
                id: 'erp',
                smooth: false,
                showAllSymbol: true,
                symbol: 'circle',
                symbolSize: 15,
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#ff1010',
                  }
                },
                itemStyle: {
                  color: '#ff1010',
                  borderColor: '#fff',
                  borderWidth: 2,
                  shadowColor: 'rgba(0, 0, 0, .3)',
                  shadowBlur: 0,
                  shadowOffsetY: 2,
                  shadowOffsetX: 2,
                },
                areaStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: 'rgba(255,16,16,0.3)'
                    },
                      {
                        offset: 1,
                        color: 'rgba(255,16,16,0)'
                      }
                    ], false),
                    shadowColor: 'rgba(255,16,16, 0.9)',
                    shadowBlur: 20
                  }
                },
                data: []
              },
              {
                name: 'SAP On Time Portion',
                type: 'line',
                smooth: false,
                showAllSymbol: true,
                symbol: 'circle',
                symbolSize: 15,
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#6c50f3',
                  }
                },
                itemStyle: {
                  color: '#6c50f3',
                  borderColor: '#fff',
                  borderWidth: 3,
                  shadowColor: 'rgba(0, 0, 0, .3)',
                  shadowBlur: 0,
                  shadowOffsetY: 2,
                  shadowOffsetX: 2,
                },
                areaStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: 'rgba(108,80,243,0.3)'
                    },
                      {
                        offset: 1,
                        color: 'rgba(108,80,243,0)'
                      }
                    ], false),
                    shadowColor: 'rgba(108,80,243, 0.9)',
                    shadowBlur: 20
                  }
                },
                data: []
              },
              {
                name: 'WMS On Time Portion',
                type: 'line',
                smooth: false,
                showAllSymbol: true,
                symbol: 'circle',
                symbolSize: 15,
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#00ca95',
                  }
                },
                itemStyle: {
                  color: '#00ca95',
                  borderColor: '#fff',
                  borderWidth: 3,
                  shadowColor: 'rgba(0, 0, 0, .3)',
                  shadowBlur: 0,
                  shadowOffsetY: 2,
                  shadowOffsetX: 2,
                },
                areaStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: 'rgba(0,202,149,0.3)'
                    },
                      {
                        offset: 1,
                        color: 'rgba(0,202,149,0)'
                      }
                    ], false),
                    shadowColor: 'rgba(0,202,149, 0.9)',
                    shadowBlur: 20
                  }
                },
                data: []
              }
            ],
            xAxisData: [],
            tooltip: {
              trigger: 'axis',
              textStyle: { align: 'left' },
              axisPointer: {
                lineStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0,
                      color: 'rgba(0, 255, 233,0)'
                    }, {
                      offset: 0.5,
                      color: 'rgba(255, 255, 255,1)',
                    }, {
                      offset: 1,
                      color: 'rgba(0, 255, 233,0)'
                    }],
                    global: false
                  }
                },
              },
              // formatter: function(params) {
                // return (
                //   `<div style="padding:5px;">${params[0]?.name}<br/>
                //     <div v-if='params[0]'><span style="width: 10px;height: 10px;border-radius: 50%;margin-right: 5px; display:inline-block;background-color:${params[0]?.color}"></span>ERP On Time Portion: ${params[0]['data'].value}</div>
                //     <span style="width: 10px;height: 10px;border-radius: 50%;margin-right: 5px; display:inline-block;background-color:${params[1]?.color}"></span>SAP On Time Portion: ${params[1]['data'].value}<br/>
                //     <span style="width: 10px;height: 10px;border-radius: 50%;margin-right: 5px; display:inline-block;background-color:${params[2]?.color}"></span>WMS On Time Portion: ${params[2]['data'].value}<br/>
                //     <div v-if='params[0]'><span style="width: 10px;height: 10px;margin-right: 5px; display:inline-block;background-color:${params[0].color}"></span>ERP Order Count: ${params[0]['data'].count}</div>
                //     <span style="width: 10px;height: 10px;margin-right: 5px; display:inline-block;background-color:${params[1].color}"></span>SAP Order Count: ${params[1]['data'].count}<br/>
                //     <span style="width: 10px;height: 10px;margin-right: 5px; display:inline-block;background-color:${params[2].color}"></span>WMS Order Count: ${params[2]['data'].count}<br/>
                //   </div>`
                // );
              // }
            },
            yAxis: [{
              type: 'value',
              max: 1,
              axisLine: {
                show: false,
              },
              axisLabel: {
                show: true,
                margin: 20,
                textStyle: {
                  color: 'black',
                },
              },
              axisTick: {
                show: false,
              },
            }]
          },
          queryParamsTime_pay: [],
          creationStartDate: moment(new Date() - 30 * 24 * 3600 * 1000).format('YYYY-MM-DD HH:mm:ss'),
          creationEndDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        },
    };
  },
  watch: {
    'lineChart.queryParamsTime_pay': {
      immediate: false,
      handler(v) {
        if (v) {
          this.lineChart.creationStartDate = (v || [])[0];
          this.lineChart.creationEndDate = (v || [])[1];
          this.getOrderPortion();
        } else {
          this.lineChart.creationStartDate = moment(new Date() - 30 * 24 * 3600 * 1000).format('YYYY-MM-DD HH:mm:ss');
          this.lineChart.creationEndDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
          this.getOrderPortion();
        }
      }
    },
    'lineChart.tabData': {
      handler(v) {
        this.getOrderPortion();
      }
    }
  },
  mounted() {
    this.getOrderPortion();
  },
  methods: {
    // 根据年和周数转换为年月日
    getDateFromYearAndWeek(year, week) {
      const start = moment().year(year).isoWeek(week - 1).isoWeekday(1).format('YYYY-MM-DD');
      const end = moment().year(year).isoWeek(week).isoWeekday(0).format('YYYY-MM-DD');
      return `${start} to\n ${end}`;
    },
    // 清空 订单占比 操作
    emptyDataPortion() {
      this.lineChart.lineChartData2.series[0].data = [];
      this.lineChart.lineChartData2.series[1].data = [];
      this.lineChart.lineChartData2.series[2].data = [];
      this.lineChart.lineChartData2.xAxisData = [];
    },
    // 获取订单占比
    getOrderPortion() {
      const data = {
        creationStartDate: this.lineChart.creationStartDate,
        creationEndDate: this.lineChart.creationEndDate,
        reportType: this.lineChart.tabData
      };
      afterApi.getOrderPortion(data).then(res => {
        if (!res.length) {
          this.emptyDataPortion();
        } else {
         this.emptyDataPortion();
          res.forEach(item => {
            this.lineChart.lineChartData2.series[0].data.push({
              value: item.erpOnTimePortion,
              count: item.erpOrderCount
            });
            this.lineChart.lineChartData2.series[1].data.push({
              value: item.sapOnTimePortion,
              count: item.sapOrderCount
            });
            this.lineChart.lineChartData2.series[2].data.push({
              value: item.wmsOnTimePortion || 1,
              count: item.wmsOrderCount
            });
            if (this.lineChart.tabData === '1') {
              this.lineChart.lineChartData2.xAxisData.push(this.getDateFromYearAndWeek(item.orderYear, item.orderDate));
            } else {
              this.lineChart.lineChartData2.xAxisData.push(`${item.orderYear}-${item.orderDate}`);
            }
          });
        }
      });
    }
  },
};
</script>
